<script>
console.clear();
import { notificationMethods } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import { http } from "@/helpers/easyindustriaapi/config";
import addSpecialty from "./add_specialty.vue";
import ProfessionalWorkingHoursForm from "./partials/ProfessionalWorkingHoursForm.vue";
import Swal from "sweetalert2";
import { isProfessionalActive } from "@/helpers/professionalStatus";

export default {
  props: {
    currentEmpresa: {
      type: Object,
      required: true,
    },
    currentProfessional: {
      type: Object,
      required: true,
    },
    vet_tratamentos: {
      type: Array,
    },
    users: {
      type: Array,
      required: true,
    }
  },
  components: { 
    addSpecialty,
    ProfessionalWorkingHoursForm,
  },
  data() {
    return {
      modal_specialty: false,
      paymentsDocument: [
        { id: 1, name: "Nota" },
        { id: 2, name: "RPA" },
      ],
      vet_update_specialty: [],
      tratamentos: [],
      listUsers: [],
      loader: {
        get: false,
      },
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Lista de profissionais",
          href: "/",
          active: true,
        },
        {
          text: "Incluir profissionais",
          href: "/profissionais/insert",
          active: true,
        },
      ],
      professional: {
        name: null,
        email: null,
        contact: null,
        birth_date: null,
        color: null,
        specialty: [],
        user_id: null,
        associated_user_id: null
      },
      logoUrl: "@/assets/crescer.png",
      titleBody: "Inserindo",
      inserindo: true,
      submitted: false,
      especialidade: [],
      workingHoursLoading: false,
      workingHoursSaving: false,
      workingHours: [],
      showReplicateModal: false,
      replicateData: {
        days: [],
        shifts: {
          manha: { start_time: '', end_time: '', enabled: false },
          tarde: { start_time: '', end_time: '', enabled: false },
          noite: { start_time: '', end_time: '', enabled: false }
        }
      },
    };
  },
  validations: {
    currentProfessional: {
      name: {
        required,
      },
      email: {
        required,
      },
      contact: {
        required,
      },
      specialty: {
        required,
      },
    },
  },
  created() {
    this.tratamentos = this.vet_tratamentos;
    this.professional = {
      ...this.currentProfessional,
      status: isProfessionalActive(this.currentProfessional) ? 1 : 0,
    };
    this.professional.birth_date = this.normalizeDateInput(this.currentProfessional?.birth_date);
    this.listUsers = this.users.map((user) => {
      return {
        text: user.name,
        value: user.id,
      };
    });

    if (Array.isArray(this.currentProfessional.specialty)) {
      this.especialidade = this.currentProfessional.specialty.map(
        (especialidade) => especialidade.id
      );
    }

    // Carregar horários de atendimento se o profissional já existe
    if (this.currentProfessional && this.currentProfessional.id) {
      this.loadWorkingHours(this.currentProfessional.id);
    }
  },
  mounted() {
    this.$emit("newTitle", "Incluir Profissional");
    this.professional = this.currentProfessional;
    this.professional.birth_date = this.normalizeDateInput(this.currentProfessional?.birth_date);
    this.vet_update_specialty = this.especialidade;
    this.novo_vetor_esspecialidade();
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    professionalColor: {
      get() {
        return this.normalizeHexColor(this.professional?.color, "#556EE6");
      },
      set(value) {
        if (!this.professional) return;
        this.professional.color = this.normalizeHexColor(value, "#556EE6");
      },
    },
    state() {
      return Boolean(this.currentProfessional.associated_user_id);
    },
    enabledShifts() {
      return Object.entries(this.replicateData.shifts).filter(([, shiftData]) => 
        shiftData.enabled && shiftData.start_time && shiftData.end_time
      );
    },
  },
  methods: {
    ...notificationMethods,
    normalizeDateInput(value) {
      if (!value) return null;
      return String(value).slice(0, 10);
    },
    normalizeHexColor(value, fallback = "") {
      const raw = String(value == null ? "" : value)
        .trim()
        .replace(/^#/, "")
        .replace(/[^0-9a-fA-F]/g, "");

      if (raw.length === 3 || raw.length === 6) {
        return `#${raw.toUpperCase()}`;
      }

      return fallback;
    },
    makeToast(variant = null, message = "Error generic") {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: "b-toaster-bottom-right",
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
    get_tratamet() {
      // Exibe o SweetAlert com loader
      Swal.fire({
        title: 'Aguarde...',
        text: 'Carregando especialidades...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Exibe o loader enquanto a requisição está em andamento
        }
      });

      const promisse = http.get("/specialty/pluck?empresa_id=" + this.currentEmpresa.id);

      return promisse.then((response) => {
        if (response.status === 200) {
          this.tratamentos = response.data;
          Swal.close(); // Fecha o loader
          return this.tratamentos || [];
        }
      }).catch((error) => {
        Swal.close(); // Fecha o loader
        Swal.fire('Erro', error.response.data.message, 'error');
      }).finally(() => {
      });
    },
    novo_vetor_esspecialidade() {
      const vet_tratamentos = this.tratamentos;

      const result = vet_tratamentos.map((specialty) => {
        if (this.especialidade.includes(specialty.id)) {
          return specialty.id; // Mantém a especialidade selecionada
        } else {
          return null; // Define id como 0 para especialidades não selecionadas
        }
      });

      this.especialidade = result;
    },
    add_specialty() {
      this.modal_specialty = true;
    },
    back_specialty() {
      this.modal_specialty = false;
    },
    back_post_new_specialty(professional) {
      this.modal_specialty = false;
      this.doPost(professional);
    },
    async get_show_prof(professional) {
      // Exibe o SweetAlert com loader
      Swal.fire({
        title: 'Aguarde...',
        text: 'Carregando dados Especialidades...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Exibe o loader enquanto a requisição está em andamento
        }
      });

      const promisse = await http.get("/professional/show?prof_id=" + professional.prof_id);

      return promisse.then((response) => {
        if (response.status === 200) {
          const vet_prof = response.data;
          this.professional = vet_prof[0];
          this.professional = vet_prof[0];

          let especialidades_aux = vet_prof[0].specialty.map(
            (especialidade) => especialidade.id
          );

          const result = this.tratamentos.map((specialty) => {
            if (especialidades_aux.includes(specialty.id)) {
              return specialty.id; // Mantém a especialidade selecionada
            } else {
              return null; // Define id como 0 para especialidades não selecionadas
            }
          });

          this.especialidade = result;

          this.vet_update_specialty = vet_prof[0].specialty.map(
            (especialidade) => especialidade.id
          );

          return vet_prof || [];
        }
      }).catch((error) => {
        console.log(error);
        Swal.close(); // Fecha o loader
        Swal.fire('Oops...', error.response.data, 'error');
      });
    },
    doPost(professional) {
      const promisse = http.post("/professional/profSpec?empresa_id=" + this.currentEmpresa.id, professional);

      return promisse.then((response) => {
        if (response.status === 200) {
          this.get_tratamet();
          this.get_show_prof(professional);
          this.makeToast("success", "Registro incluído com sucesso!");
          return response.data;
        }
      }).catch((error) => {
        this.makeToast("danger", error.response);
        Swal.close();
        Swal.fire('Oops...', error.response.data, 'error');
      });

    },
    vetor_especialidades() {
      const especialidades = [
        { id: 1, name: "psicologia" },
        { id: 2, name: "fisioterapia" },
        { id: 3, name: "nutrição" },
      ];

      // Cria um novo vetor contendo apenas os IDs
      const idsEspecialidades = especialidades.map(
        (especialidade) => especialidade.id
      );

      console.log(idsEspecialidades); // [1, 2, 3]
    },
    // eslint-disable-next-line no-unused-vars
    formSubmit(e) {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.currentProfessional.$error) {
        this.makeToast("danger", "Erro de validação!");
      } else {
        this.$emit("doPut", this.currentProfessional);
      }
    },
    setPut() {
      this.professional.vet_update_specialty = this.vet_update_specialty;
      this.professional.birth_date = this.normalizeDateInput(this.professional?.birth_date);
      this.professional.color = this.normalizeHexColor(this.professional?.color, null);
      this.professional.status = Number(this.professional.status) === 1 ? 1 : 0;
      this.$emit("doPut", this.professional);
    },
    select_specialty(item, index, event) {
      if (this.especialidade[index]) {
        this.especialidade[index] = parseInt(event.target.value);
        console.log(this.especialidade);
      } else {
        const updatedArray = this.professional.specialty.filter(
          (item) => item.id != event.target.value
        );
        console.log(this.especialidade);
        console.log(updatedArray);
      }

      // vet_back = this.especialidade
      const specialtyNumberVet = this.especialidade.filter(
        (item) => typeof item === "number"
      );

      // console.log(specialtyNumberVet)
      if (specialtyNumberVet.length == 0) {
        this.makeToast("danger", "selecione uma especialidade");
      }
      this.vet_update_specialt = [];
      this.vet_update_specialty = specialtyNumberVet;
      console.log(this.vet_update_specialty);
    },
    deatach() {
      this.professional.associated_user_id = null;
      this.currentProfessional.associated_user_id = null;
    },
    back() {
      this.$emit("back");
    },
    async loadWorkingHours(professionalId = null) {
      const targetProfessionalId = professionalId || this.currentProfessional?.id || this.professional?.id;

      if (!targetProfessionalId) {
        return;
      }

      this.workingHoursLoading = true;
      try {
        const response = await http.get(`/professional/${targetProfessionalId}/working-hours`);
        this.workingHours = response.data?.data || [];
      } catch (error) {
        this.makeToast("danger", "Erro ao carregar horários de atendimento");
      } finally {
        this.workingHoursLoading = false;
      }
    },
    async saveWorkingHours(updatedHours) {
      const targetProfessionalId = this.currentProfessional?.id || this.professional?.id;

      if (!targetProfessionalId) {
        return;
      }

      this.workingHoursSaving = true;
      try {
        const response = await http.put(`/professional/${targetProfessionalId}/working-hours`, {
          working_hours: updatedHours,
        });
        this.workingHours = response.data?.data || [];
        this.makeToast("success", "Horários de atendimento atualizados com sucesso!");
      } catch (error) {
        this.makeToast("danger", "Erro ao salvar horários de atendimento");
        throw error;
      } finally {
        this.workingHoursSaving = false;
      }
    },
    openReplicateModal() {
      this.showReplicateModal = true;
      // Reset form
      this.replicateData = {
        days: [],
        shifts: {
          manha: { start_time: '', end_time: '', enabled: false },
          tarde: { start_time: '', end_time: '', enabled: false },
          noite: { start_time: '', end_time: '', enabled: false }
        }
      };
    },
    closeReplicateModal() {
      this.showReplicateModal = false;
    },
    replicateWorkingHours() {
      if (this.replicateData.days.length === 0) {
        this.makeToast("warning", "Selecione pelo menos um dia da semana");
        return;
      }

      // Verificar se pelo menos um turno está habilitado e preenchido
      const hasValidShift = Object.values(this.replicateData.shifts).some(shift => 
        shift.enabled && shift.start_time && shift.end_time
      );

      if (!hasValidShift) {
        this.makeToast("warning", "Configure pelo menos um turno com horários válidos");
        return;
      }

      // Criar novos horários baseados na replicação
      const newHours = [];
      
      this.replicateData.days.forEach(day => {
        Object.entries(this.replicateData.shifts).forEach(([shiftName, shiftData]) => {
          if (shiftData.enabled && shiftData.start_time && shiftData.end_time) {
            newHours.push({
              day_of_week: day,
              shift: shiftName,
              start_time: shiftData.start_time,
              end_time: shiftData.end_time
            });
          }
        });
      });

      // Atualizar os horários locais
      this.workingHours = [...this.workingHours, ...newHours];
      
      this.makeToast("success", `Horários replicados com sucesso para ${this.replicateData.days.length} dia(s)`);
      this.closeReplicateModal();
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-12">
      <form @submit.prevent="formSubmit" name="formProfissional" id="formProfissional">
        <div class="form-row col-md-12 mt-4">
          <div class="form-group col-md-3">
            <label for="name">NOME DO PROFISSIONAL:</label>
            <input
              id="name"
              type="text"
              class="form-control"
              v-model="professional.name"
              maxlength="100"
              placeholder="Nome do Profissional"
            />
          </div>
          <div class="form-group col-md-3">
            <label for="council">Conselho regional:</label>
            <input
              id="council"
              type="text"
              class="form-control"
              v-model="professional.council"
              maxlength="6"
              placeholder="Ex: CRM"
            />
          </div>
          <div class="form-group col-md-3">
            <label for="credential">Credencial:</label>
            <input
              id="credential"
              type="number"
              class="form-control"
              v-model="professional.credential"
              maxlength="6"
              placeholder="Ex: "
            />
          </div>
          <div class="form-group col-md-3">
            <label for="birth_date">Data de nascimento:</label>
            <input
              id="birth_date"
              type="date"
              class="form-control"
              v-model="professional.birth_date"
            />
          </div>
        </div>
        <div class="form-row col-md-12">
          <div class="form-group col-md-4">
            <label for="email">E-MAIL:</label>
            <input
              id="email"
              type="email"
              class="form-control"
              v-model="professional.email"
              placeholder="Ex: profisional@email.com"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="contact">CONTATO TELEFÔNICO:</label>
            <input
              id="contact"
              type="tel"
              class="form-control"
              v-mask="'## #####-####'"
              v-model="professional.contact"
              placeholder="Ex: 12934567889"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="documento_pagamento">Forma de pagamento:</label>
            <b-form-select v-model="professional.payment_document">
              <option v-for="(item, index) in paymentsDocument" :key="index=item.id">{{ item.name }}</option>
            </b-form-select>
          </div>
          <div class="form-group col-md-4">
            <label for="professional_status">Situação:</label>
            <b-form-select id="professional_status" v-model="professional.status">
              <option :value="1">Ativo</option>
              <option :value="0">Inativo</option>
            </b-form-select>
          </div>
        </div>
        <div class="form-row col-md-12">
          <div class="form-group col-md-6">
            <label for="professional_color">Cor na agenda:</label>
            <div class="professional-color-field">
              <input
                id="professional_color_picker"
                v-model="professionalColor"
                type="color"
                class="professional-color-picker"
                title="Selecionar cor"
              />
              <input
                id="professional_color"
                v-model.trim="professional.color"
                type="text"
                class="form-control"
                maxlength="7"
                placeholder="#556EE6"
                @blur="professional.color = normalizeHexColor(professional.color, '')"
              />
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="professional.color = '#556EE6'"
              >
                Padrão
              </button>
            </div>
            <div class="professional-color-preview mt-2">
              <span
                class="professional-color-preview__swatch"
                :style="{ backgroundColor: professionalColor }"
              ></span>
              <span class="text-muted small">
                Pré-visualização: {{ normalizeHexColor(professional.color, "#556EE6") }}
              </span>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-12">
            <label for="">Especialidades:</label>
            <div class="row">
              <div
                v-for="(item, index) in tratamentos"
                :key="index"
                class="col-md-4"
              >
                <div class="form-check">
                  <input
                    class="form-check-input"
                    v-model="especialidade[index]"
                    @change="select_specialty(item, index, $event)"
                    type="checkbox"
                    :id="'specialty-' + item.id"
                    :value="item.id"
                  />
                  <label
                    class="form-check-label"
                    for="specialty-neuropediatria"
                  >
                    {{ item.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4 d-flex justify-content-center align-items-center">
          <div class="col-md-12 text-center">
            <button class="btn btn-secondary" @click.prevent="add_specialty()">
              Adicionar Especiliade
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-modal
              v-model="modal_specialty"
              title="Adicionar Especialidade"
              title-class="font-18"
              @hidden="back_specialty()"
              hide-footer
            >
              <addSpecialty
                @back_post_new_specialty="back_post_new_specialty"
                :curretProf="currentProfessional"
              />
            </b-modal>
          </div>
        </div>
        <div class="form-row col-md-12 mt-4">
          <div class="form-group col-md-12">
            <label>Usuário associado:</label>
            <b-form-radio-group
             id="professional_associated_user_id"
             form="formProfissional"
             label="Usuário"
             v-model="professional.associated_user_id"
             :options="listUsers"
             :state="state"
             value-field="value"
             text-field="text"
             name="associated_user_id"
             class="mb-3"
            >
            </b-form-radio-group>
            <b-button v-if="state" variant="warning" @click.prevent="deatach()">
              <i class="ri-close-line align-middle mr-2"></i>Desassociar usuário
            </b-button>
          </div>
        </div>
        <div class="col-md-12 mt-4">
          <button
            class="btn btn-primary"
            style="margin-right: 20px"
            @click.prevent="setPut()"
          >
            Gravar
          </button>
        </div>
      </form>
      
      <!-- Seção de Horários de Atendimento -->
      <b-card class="mb-3 mt-4">
        <template #header>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h5 class="mb-0">Horários de Atendimento</h5>
              <small class="text-muted">Configure os horários de disponibilidade do profissional</small>
            </div>
            <div>
              <b-button 
                variant="outline-primary" 
                size="sm" 
                @click="openReplicateModal"
                class="mr-2"
              >
                <i class="ri-copy-line mr-1"></i>
                Replicar Horário
              </b-button>
            </div>
          </div>
        </template>
        <ProfessionalWorkingHoursForm
          :working-hours="workingHours"
          :loading="workingHoursLoading"
          :saving="workingHoursSaving"
          @save="saveWorkingHours"
        />
      </b-card>
      
      <!-- Modal de Replicação de Horários -->
      <b-modal
        v-model="showReplicateModal"
        title="Replicar Horários"
        size="lg"
        @hidden="closeReplicateModal"
        ok-title="Replicar"
        cancel-title="Cancelar"
        @ok="replicateWorkingHours"
      >
        <div class="replicate-modal-content">
          <p class="text-muted mb-3">
            Configure os horários que deseja replicar para múltiplos dias da semana.
          </p>
          
          <!-- Seleção de Dias -->
          <div class="mb-4">
            <h6>Selecione os dias da semana:</h6>
            <div class="row">
              <div class="col-md-4" v-for="day in [1,2,3,4,5,6,7]" :key="day">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="`replicate-day-${day}`"
                    :value="day"
                    v-model="replicateData.days"
                  />
                  <label class="form-check-label" :for="`replicate-day-${day}`">
                    {{ $t(`mesages.professional.working_hours.days.${day}`) }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Configuração de Turnos -->
          <div class="mb-3">
            <h6>Configure os turnos:</h6>
            <div class="row">
              <div class="col-md-4" v-for="(shift, shiftName) in replicateData.shifts" :key="shiftName">
                <div class="card">
                  <div class="card-header p-2">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`replicate-shift-${shiftName}`"
                        v-model="shift.enabled"
                      />
                      <label class="form-check-label font-weight-bold" :for="`replicate-shift-${shiftName}`">
                        {{ $t(`mesages.professional.working_hours.shifts.${shiftName}`) }}
                      </label>
                    </div>
                  </div>
                  <div class="card-body p-2" v-if="shift.enabled">
                    <div class="form-group mb-2">
                      <label class="small">Horário de Início:</label>
                      <input
                        type="time"
                        class="form-control form-control-sm"
                        v-model="shift.start_time"
                        :disabled="!shift.enabled"
                      />
                    </div>
                    <div class="form-group mb-0">
                      <label class="small">Horário de Fim:</label>
                      <input
                        type="time"
                        class="form-control form-control-sm"
                        v-model="shift.end_time"
                        :disabled="!shift.enabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Preview dos horários que serão criados -->
          <div v-if="replicateData.days.length > 0 && Object.values(replicateData.shifts).some(s => s.enabled && s.start_time && s.end_time)" class="mt-3">
            <h6>Preview dos horários que serão criados:</h6>
            <div class="alert alert-info">
              <small>
                <strong>Dias selecionados:</strong> {{ replicateData.days.map(d => $t(`mesages.professional.working_hours.days.${d}`)).join(', ') }}<br>
                <strong>Turnos configurados:</strong>
                <ul class="mb-0 mt-1">
                  <li v-for="[shiftName, shiftData] in enabledShifts" :key="shiftName">
                    {{ $t(`mesages.professional.working_hours.shifts.${shiftName}`) }}: {{ shiftData.start_time }} - {{ shiftData.end_time }}
                  </li>
                </ul>
              </small>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
  <!-- </layout> -->
</template>

<style scoped>
.professional-color-field {
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr) auto;
  gap: 0.5rem;
  align-items: center;
}

.professional-color-picker {
  width: 52px;
  height: 38px;
  padding: 0.2rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background: #fff;
  cursor: pointer;
}

.professional-color-preview {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.professional-color-preview__swatch {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.8);
}
</style>